// Sidebar
export const TOGGLE_NAV = "TOGGLE_NAV";

// Vehicle
export const TOGGLE_ADD_VEHICLE_DIALOG = "TOGGLE_ADD_VEHICLE_DIALOG";
export const TOGGLE_EDIT_VEHICLE_DIALOG = "TOGGLE_EDIT_VEHICLE_DIALOG";
